module.exports = __webpack_public_path__ + "4b7eb4a1443a87391ed820e97b952264.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img10.png
// module id = 1316
// module chunks = 0